<template>
  <div class="demo-split" style="height: 100%">
    <Split v-model="split1">
      <div slot="left" class="demo-split-pane">
        <left-detail
          v-if="detailFlag"
          :detailData="detailData"
          :instApplyId="instApplyId"
          @updateDetailData="updateDetailData"
          :detailDataChangeCount="detailDataChangeCount"
        />
      </div>
      <div slot="right" class="demo-split-pane">
        <right-flow-path :detailData="detailData" :selfUserId="selfUserId" />
      </div>
    </Split>
  </div>
</template>

<script>
import leftDetail from './template/leftDetail/leftDetail.vue'; // 左侧详情
import rightFlowPath from './template/rightFlowPath/rightFlowPath.vue'; // 右侧流程
import { instApplyDetailApi } from '@/api/approvalTask';
export default {
  components: { leftDetail, rightFlowPath },
  data() {
    return {
      split1: 0.75,
      instApplyId: '',
      detailData: {},
      selfUserId: '', // 当前登录人id
      detailFlag: false,
      detailDataChangeCount: 0 // 详情变化次数,用于在本页更改数据之后不刷新页面，直接用watch监听detailData负荷太大，页面容易卡
    };
  },
  methods: {
    async updateDetailData() {
      await this.getDetail(this.instApplyId);
      this.detailDataChangeCount++;
    },
    async getDetail(instApplyId) {
      // 用异步是为了在本页更改数据之后刷新数据
      await instApplyDetailApi(instApplyId).then(res => {
        const { data } = res.data;
        this.detailFlag = true;
        this.detailData = data;
      });
    }
  },
  created() {
    const { instApplyId } = this.$route.query;
    this.selfUserId = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo).id
      : '';
    this.instApplyId = instApplyId;
    this.getDetail(instApplyId);
  }
};
</script>

<style scoped>
.demo-split {
  height: 200px;
  border: 1px solid #dcdee2;
}
.demo-split-pane {
  overflow: scroll;
  height: 100%;
  padding: 10px;
}
</style>
